export const addEditToolEmptyState_style = {
  rootSx: {
    cursor: 'pointer',
  },
};
